<script lang="ts">
    import Icon from "@components/material/Icon.svelte"
    import type { ToastType } from "@utils/utilities/toasts"
    import { fade } from "svelte/transition"

    export let toast: ToastType
</script>

<div
    out:fade|global
    class="pointer-events-auto py-4 px-4 text-lg rounded-lg bg-neutral-100 bg-opacity-90 dark:bg-black dark:bg-opacity-80 dark:text-white"
>
    {#if toast.icon}
        <Icon icon={toast.icon} class="mr-2 w-6 inline-block" />
    {/if}
    {toast.msg}
</div>
